const $ = require('jquery');

if (!window.vf) {
    window.vf = {};
}


require('./back-to-top/back-to-top.js');
require('./header/header.js');
require('./footer/footer.js');
require('./base.scss');
require('lite-youtube-embed');
require('lite-youtube-embed/src/lite-yt-embed.css');

window.$ = window.jQuery = $;

require('./services');
require('./global-search/global-search.js');

require('./components/ContactFormFlow/factory.js');
require('./components/ContactFormFlowEmbed/factory.js');
require('./components/newContactFormFlow/index/brochures/factory.js');
require('./components/newContactFormFlow/index/financialModel/factory.js');
require('./components/newContactFormFlow/index/financialModelCta/factory.js');


$(() => {
    if (window.vf.contactFormFlow) {
        window.vf.contactFormFlow.register();
    }
    if (window.vf.contactFormFlowEmbed) {
        window.vf.contactFormFlowEmbed.register();
    }
    if (window.vf.contactFormFlowBrochure) {
        window.vf.contactFormFlowBrochure.register();
    }
    if (window.vf.contactFormFlowFinancialModel) {
        window.vf.contactFormFlowFinancialModel.register();
    }
    if (window.vf.contactFormFlowFinancialModelCta) {
        window.vf.contactFormFlowFinancialModelCta.register();
    }
});